import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Chip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SearchBox from "../../components/reusableComponents/SearchBox"; // Import SearchBox
import { styled } from "@mui/system";
import { useLocation, useHistory } from "react-router-dom";

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: "10px",
  color: "#545454",
  background: "#fff",
  border: "0px",
  padding: "6px 20px 6px 20px",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: "#ED1C24",
    color: "#fff",
  },
  "&.MuiChip-clickable:focus, &.MuiChip-clickable:hover": {
    backgroundColor: "#ED1C24",
    color: "#fff",
  },
  "&.MuiChip-clickable": {
    "&.Mui-active": {
      backgroundColor: "#ED1C24",
      color: "#fff",
    },
  },
}));

const DiscoverableTabs = ({
  discoverTabs,
  activeChip,
  playlistCall,
  activeLabel,
  handleChipClick,
  selectedTab,
  setSelectedTab,
  handleSearchInput,
  searchValue,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();
  const location = useLocation();


  const handleSelectChange = (event) => {
    const selectedLabel = event.target.value;
    setSelectedTab(selectedLabel);
    // playlistCall(selectedValue)
    const labelIndex = discoverTabs.findIndex((tab) => tab.label === selectedLabel);
  if (labelIndex !== -1) {
    const selectedValue = discoverTabs[labelIndex].value[0]; // You may choose another value logic
    const chipIndex = `${labelIndex}-0`; // assuming 0th item is selected
    handleChipClick(chipIndex, selectedLabel, selectedValue);
  }
    history.push(`?tab=${selectedLabel}`, { value: selectedLabel });
  };

  return (
    <Box className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
      {/* Show chips on larger screens */}
      {!isMobile && (
        <Stack direction="row" spacing={1}>
          {discoverTabs.map((d, i) =>
            d.value.map((v, index) => (
              <StyledChip
                key={`${i}-${index}`}
                label={v}
                component="a"
                variant="outlined"
                clickable
                onClick={() => handleChipClick(`${i}-${index}`, d.label, v)}
                className={activeChip === `${i}-${index}` ? "Mui-active" : ""}
              />
            ))
          )}
        </Stack>
      )}

      {/* Show select dropdown on mobile screens */}
      {isMobile && (
        <FormControl size="small" fullWidth>
          <Select
            id="select-tabs"
            value={selectedTab}
            onChange={handleSelectChange}
            sx={{ minWidth: 120 }}
            displayEmpty
          >
            {/* Dynamically create MenuItems based on discoverTabs */}
            {discoverTabs.map((d, index) => (
              <MenuItem key={index} value={d.label}>
                {d.value[0]} {/* Display the first item in the value array */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Only show SearchBox if the active label is 'all' */}
      {activeLabel === "all" && (
        <SearchBox
          searchValue={searchValue}
          handleSearchInput={handleSearchInput}
          placeholder={"Search"}
        />
      )}
    </Box>
  );
};

export default DiscoverableTabs;
